'use client';

import { usePlausible } from 'next-plausible';
import { captureEvent } from './posthog';

/**
 * Custom hook that provides unified analytics tracking across both PostHog and Plausible
 *
 * @returns An object with a trackEvent function that sends events to both analytics platforms
 */
export function useAnalytics() {
  // Initialize Plausible hook
  const plausible = usePlausible();

  /**
   * Track an event in both PostHog and Plausible
   *
   * @param eventName The name of the event to track
   * @param properties Optional properties to include with the event
   */
  const trackEvent = (eventName: string, properties?: Record<string, any>) => {
    // Track in PostHog
    captureEvent(eventName, properties);

    // Track in Plausible
    // Note: Plausible only accepts specific properties in their props object
    plausible(eventName, {
      props: properties,
    });
  };

  return { trackEvent };
}
